var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSecure = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "#1B1F23",
  "aria-hidden": "true",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6 16a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1V17a1 1 0 0 0-1-1zm9 6.732A2 2 0 0 1 16 19a2 2 0 0 1 1 3.732V26a1 1 0 1 1-2 0zM8 14V7a7 7 0 0 1 7-7h2a7 7 0 0 1 7 7v7h2a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V17a3 3 0 0 1 3-3zm2 0h12V7a5 5 0 0 0-5-5h-2a5 5 0 0 0-5 5zM5 26h6v2H5zm16 0h6v2h-6z"
})));
export default SvgSecure;